// @flow

import { findRoutes } from 'redux-router-kit';

const doMatchedRoutesMatch = (doesRouteMatch: (route: {}) => boolean) => (
  routes: Array<{}>,
  routeKey: string
) => {
  const matchedRoutes = findRoutes(routes, routeKey) || [];
  return matchedRoutes.some(route => doesRouteMatch(route));
};

export default doMatchedRoutesMatch;
